(function() {

  const form = document.querySelector('[data-product-form-ajax]');
  const addToCartBtn = form.querySelector('[data-add-to-cart-ajax]');
  const promoInputs = form.querySelectorAll('input[name="properties[_promo]"]');
  const promoRegex = /freeze-p(\d+)c(\d+)x(\d+)z(\d+)/;

  var selected = [];

  if (promoInputs.length) {
    promoInputs[0].checked = true;
  }

  addToCartBtn.addEventListener('click', function() {
    console.log("CYC OrderButton Clicked");
    var id = parseFloat(addToCartBtn.dataset.addToCartVariant);
    var qtyInput = form.querySelector('input[name="quantity"]');
    var selectedRebate = form.querySelector('input[name="properties[rebate]"]:checked');
    var selectedRebateKey = form.querySelector('input[name="properties[_rebate_key]"]');
    var selectedPromo = form.querySelector('input[name="properties[_promo]"]:checked');
    var selectedPromocyc = form.querySelector('input[name="properties[_cycpromo]"]:checked');

    selected = [{
      id: id,
      quantity: parseInt(qtyInput.value),
      properties: {}
    }];

    if (selectedRebate) {
      selected[0]["properties"]["rebate"] = selectedRebate.value;
      selected[0]["properties"]["_rebate_key"] = selectedRebateKey.value;
    }
    
    if (selectedPromo) {
      if (selectedPromo.value.match(promoRegex)) {
        var [key, productID, promoId, promoQty, secret] = selectedPromo.value.match(promoRegex);
        selected.splice(0, 0, 
          {
            id: parseFloat(promoId),
            quantity: parseInt(promoQty) * parseInt(qtyInput.value),
            properties: {
              _promo: `freeze-c${promoId}p${productID}x${promoQty}z${secret}`,
              note: 'Parent Item Required to recieve free product'
            }
          }
        );
      }
      else {
        selected[0]["properties"]["_promo"] = selectedPromo.value;
      }
    } 
     
    if (selectedPromocyc) {
      if (selectedPromocyc.value.match(promoRegex)) {
        var [key, productID, promoId, promoQty, secret] = selectedPromo.value.match(promoRegex);
        selected.splice(0, 0, 
          {
            id: parseFloat(promoId),
            quantity: parseInt(promoQty) * parseInt(qtyInput.value),
            properties: {
              _promo: `freeze-c${promoId}p${productID}x${promoQty}z${secret}`
            }
          }
        );
      }
      else {
        selected[0]["properties"]["_cycpromo"] = selectedPromocyc.value;
      }
    } 

    handleAddToCart(selected);
    var cycitemname = $(".cycvarname").html();
    $("#cart-status").html("Item: " + cycitemname + ". Added to Cart");

  });

  function handleAddToCart(selected) {
    
    if (addToCartBtn.classList.contains('loading')) return;

    addToCartBtn.setAttribute('aria-disabled', true);
    addToCartBtn.classList.add('loading');
    addToCartBtn.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      ...{ 'items': selected },
      sections_url: window.location.pathname
    });
    
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) return;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        addToCartBtn.classList.remove('loading');
        addToCartBtn.removeAttribute('aria-disabled');
        addToCartBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
        
        document.dispatchEvent(new CustomEvent('cart:drawer:open', { bubbles: true }));
      });
  }

})();